"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationWorkflowTracker = exports.ApplicationWorkflowEventTypes = void 0;
var csod = require("player-core");
var tracker_defaults_1 = require("@csod/tracker-defaults");
var ReferralTokenHelper_1 = require("./ReferralTokenHelper");
var ApplicationWorkflowEventTypes = (function () {
    function ApplicationWorkflowEventTypes() {
    }
    ApplicationWorkflowEventTypes.start = 'First Application Page Load';
    ApplicationWorkflowEventTypes.next = 'Next in Application Workflow';
    ApplicationWorkflowEventTypes.back = 'Navigate Back in Application Workflow';
    ApplicationWorkflowEventTypes.cancel = 'Cancel Application Workflow';
    ApplicationWorkflowEventTypes.submit = 'Submit Application Workflow';
    ApplicationWorkflowEventTypes.save = 'Save Application Workflow';
    ApplicationWorkflowEventTypes.sawBranchedPSQ = 'Saw Branched PSQ';
    ApplicationWorkflowEventTypes.doNotTrackSeenBPSQ = '';
    return ApplicationWorkflowEventTypes;
}());
exports.ApplicationWorkflowEventTypes = ApplicationWorkflowEventTypes;
var ApplicationWorkflowTracker = (function () {
    function ApplicationWorkflowTracker() {
        this.trackApplicationWorkflow = function (eventName, hasSeenBPSQ, furthestPageVisited) {
            var track = tracker_defaults_1.getActionCreators().track;
            var contextKeys = ['user', 'corp', 'cultureName', 'timezone', 'correlation'];
            var userId = csod.context.user;
            userId < 0 && contextKeys.shift();
            var userData = tracker_defaults_1.getUserProperties(contextKeys);
            var _a = csod.viewModel, reqId = _a.reqId, jobDetail = _a.jobDetail, workflowPage = _a.workflowPage, isCareerCenter = _a.isCareerCenter, careerSiteId = _a.careerSiteId;
            var source;
            if (!isCareerCenter) {
                if (careerSiteId) {
                    source = 'Career Site';
                }
                else {
                    source = 'Other';
                }
            }
            else {
                source = 'Internal Career Site';
            }
            var referralToken = ReferralTokenHelper_1.getReferralTokenFromPage();
            var eventData = {
                eventName: eventName,
                applicationType: 'Mobile Friendly Experience',
                reqId: reqId,
                jobTitle: jobDetail.displayTitle,
                jobLocation: jobDetail.primaryLocation.title,
                jobPositionOu: '',
                jobDivisionName: '',
                'Total Page Count': workflowPage.totalPages,
                currentPage: workflowPage.currentPage,
                lastPageVisited: furthestPageVisited,
                'Has Seen Branched PSQs': hasSeenBPSQ.toString(),
                source: source,
                'Used Referral Link': referralToken ? 'Yes' : 'No',
                'Product Suite': 'Recruiting',
            };
            var trackAction = track({
                userData: userData,
                eventData: eventData,
            });
        };
        this.seenBranchPSQs = false;
        this.doNotTrackSeenBPSQ = '';
    }
    return ApplicationWorkflowTracker;
}());
exports.ApplicationWorkflowTracker = ApplicationWorkflowTracker;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/shared/code/ApplicationWorkflowTracker.ts
// module id = 228
// module chunks = 0